import src from "IMAGE";
export default { src, width: 365, height: 404, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
